import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// Consider moving functionality to shared folder:
// eslint-disable-next-line @nx/enforce-module-boundaries
import { LogoutModal } from '@authentication/feature-login';
import { windowProvider } from '@inshared/shared/util';
import { AuthorizeBeforeRedirectModule, DirectivesModule } from '@inshared/shared/util-directives';
import { CookieStorage, SessionStorage, SessionStorageService, StorageService } from '@inshared/shared/util-storage';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { AutorisatieMenuModule } from '../autorisatie-menu/autorisatie-menu.module';
import { NavigationModule } from '../navigation/navigation.module';
import { TopbarModule } from '../topbar/topbar.module';
import { HeaderComponent } from './header.component';

@NgModule({
    imports: [
        AuthorizeBeforeRedirectModule,
        CommonModule,
        DirectivesModule,
        LazyLoadImageModule,
        LogoutModal,
        NavigationModule,
        RouterModule,
        AutorisatieMenuModule,
        TopbarModule,
    ],
    declarations: [HeaderComponent],
    exports: [HeaderComponent],
    providers: [
        { provide: SessionStorageService, useClass: SessionStorage },
        { provide: StorageService, useClass: CookieStorage },
        windowProvider,
    ],
})
export class HeaderModule {}
